import { css } from 'emotion';
import { ModalSize } from '../types';
import { fontFamily, breakpoints } from '@joykit/variables';

const modalSize: { [size in ModalSize]: string | undefined } = {
  small: '768px',
  normal: '768px',
  medium: '768px',
  large: '768px',
  fitToSize: undefined
};

const getBreakpoints = (size: ModalSize) => {
  let extraLargeWidth, largeWidth, mediumWidth, smallWidth;

  switch (size) {
    case 'small': {
      extraLargeWidth = 540;
      largeWidth = 510;
      mediumWidth = '52.8%';
      smallWidth = '95%';
      break;
    }
    case 'normal': {
      extraLargeWidth = 720;
      largeWidth = 680;
      mediumWidth = '70.4%';
      smallWidth = '95%';
      break;
    }
    default: {
      // fitToSize
      extraLargeWidth = '80vw';
      largeWidth = '80vw';
      mediumWidth = '88%';
      smallWidth = '95%';
    }
  }

  return {
    [`@media(max-width: ${breakpoints.medium - 1}px)`]: {
      maxWidth: smallWidth // '95%'
    },
    [`@media(min-width: ${breakpoints.medium}px)`]: {
      maxWidth: mediumWidth // '88%'
    },
    [`@media(min-width: ${breakpoints.large}px)`]: {
      maxWidth: largeWidth // '80vw',
    },
    [`@media(min-width: ${breakpoints.extraLarge}px)`]: {
      maxWidth: extraLargeWidth // '80vw',
    }
  };
};

const BORDER_RADIUS = 8;

export namespace styles {
  export const container = (size: ModalSize, scrolling: boolean) => {
    const mediaQueries = getBreakpoints(size);
    return css(
      {
        fontFamily,
        opacity: 0,
        transform: 'scale(1.1)',
        width: modalSize[size],
        zIndex: 1500,
        position: 'relative',
        boxShadow: 'rgba(0, 0, 0, 0.25) 0px 14px 45px, rgba(0, 0, 0, 0.22) 0px 10px 18px',
        borderRadius: BORDER_RADIUS,
        backgroundColor: '#fff',
        ' > :first-child:not(.icon)': {
          borderTopLeftRadius: BORDER_RADIUS,
          borderTopRightRadius: BORDER_RADIUS
        },
        ' > :last-child:not(.icon)': {
          borderBottomLeftRadius: BORDER_RADIUS,
          borderBottomRightRadius: BORDER_RADIUS
        },
        ...mediaQueries
      },
      scrolling
        ? {
            margin: '1.5em auto'
          }
        : undefined
    );
  };
}
